import React from 'react';
import { useTranslation } from 'react-i18next';

import CLFontIcon from '../../components/CLFontIcon';

import { NotAvailable } from './styled';

const ListingNotAvailable = () => {
  const { t } = useTranslation();

  return (
    <NotAvailable>
      <CLFontIcon icon="blocked" />
      <span>{t('not_available', 'Not available')}</span>
    </NotAvailable>
  );
};

export default ListingNotAvailable;
